import React, { useState, useRef } from 'react';
import { Grid, Button, Typography, Card, CardActionArea, CardMedia, CardContent, CardActions, Tooltip, Paper } from '@mui/material';
import UploadImg from '../../assets/images/ui/add-image-wide.png';
import { api } from '../../api/instance';
import deleteUpload from '../../utils/deleteUpload';

/**
 * 
 * @param {String} type to control text shown in the uploader e.g. "projects"
 * @param {String} apiPath the api path to upload images
 * @param {Array} images array of images to manage
 * @param {Function} setter state setter to update images when uploaded/deleted
 * @returns Component that uploads images and update state
 */
const ProjectImageUpload = ({ type, apiPath, images = 0, setter }) => {
  const [file, setFile] = useState();
  const [uploading, setUploading] = useState();
  const formUploadRef = useRef();

  const fileChange = (e) => {
    setUploading(true);
    setFile(e.target.files[0]);

    const form = formUploadRef.current; // or document.forms
    const formData = new FormData(form);
    formData.fileUpload = e.target.files[0];

    api
      .post(apiPath, formData)
      .then((response) => {
        const imageData = {
          path: response.data.filePath,
          order: images.length + 1,
          name: response.data.fileName,
          size: response.data.fileSize,
        }; //get values from

        if (response.status === 201) {
          setter((prevState) => ({
            ...prevState,
            images: [...(prevState.images || []), imageData],
          }));
          setUploading(false);
        }
      })
      .catch((error) => {
        console.log('Error Uploading', error);
        setUploading(false);
      });
  };

  return (
    <>
      <Typography variant="h5" className="lato" sx={{ marginTop: '2rem' }}>
        {type.toUpcase} Images
      </Typography>
      <Typography variant="body1" className="lato">
        5 images per {type} recommended. {images ? `${images?.length} uploaded` : 'no images uploaded'}
      </Typography>
      <Grid container spacing={{ xs: 2, md: 3 }}>
        {images ? (
          images.map((item) => (
            <Grid item xs={12} sm={6} md={6} sx={{ marginTop: '2rem' }} key={item.order}>
              <Card>
                <CardActionArea>
                  <CardMedia style={{ height: 200 }} image={item.path} title={item.name} />
                  <CardContent>
                    <Typography gutterBottom variant="overline" component="h2">
                      {item.order} - {item.name}
                    </Typography>
                  </CardContent>
                </CardActionArea>
                <CardActions>
                  <Button size="small" color="error" onClick={() => deleteUpload(item.path, setter)}>
                    DELETE
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))
        ) : (
          <Grid item xs={12} sm={6} md={6} sx={{ marginTop: '2rem' }}>
            <Typography variant="body1" className="lato">
              No Images
            </Typography>
          </Grid>
        )}
      </Grid>

      {uploading ? 'uploading image' : ''}

      <Grid item xs={12} sx={{ marginTop: '2rem', marginBottom: '2rem' }}>
        <Paper elevation={2} sx={{ padding: '1rem' }}>
          <form id="uploadFile" className="input-image-upload large-12 medium-12 small-12 cell" ref={formUploadRef}>
            <div className="callout center round-medium no-padding" data-tooltip title="CLICK TO UPLOAD">
              <Tooltip title="Click to upload image" placement="top-end">
                <label htmlFor="fileUpload">
                  <img id="image-1" src={UploadImg} alt="upload" sx={{ border: 'solid 1px #ccc', borderRadius: '1rem' }} width="100%" />
                </label>
              </Tooltip>
              <input type="file" name="fileUpload" id="fileUpload" className="inputfile inputfile-2 is-hidden" onChange={(e) => fileChange(e)} />
            </div>
          </form>
        </Paper>
      </Grid>
    </>
  );
};

export default ProjectImageUpload;
